import React from 'react';

import styles from './OperatorGenericInformation.module.css';

const isGenericInformationAvailable = ({
  noOfBuses,
  noOfRoutes,
  areaServedBy,
  typeOfBuses
}) => {
  if (
    (noOfBuses == null || noOfBuses == 0) &&
    (noOfRoutes == null || noOfRoutes == 0) &&
    (areaServedBy == null || areaServedBy.length == 0) &&
    (typeOfBuses == null || typeOfBuses.length == 0)
  ) {
    return false;
  }
  return true;
};

const OperatorGenericInformation = ({
  operatorName,
  ownedBy,
  headOffice,
  noOfBuses,
  noOfRoutes,
  areaServedBy,
  typeOfBuses
}) => {
  return isGenericInformationAvailable({
    noOfBuses,
    noOfRoutes,
    areaServedBy,
    typeOfBuses
  }) ? (
    <div style={{ paddingTop: '15px' }}>
      <h2
        className={'desktopShow'}
      >{`Basic information for ${operatorName}`}</h2>

      <h2
        style={{ display: 'none' }} // disabled in SSR HTML
        className="mobileShow paddingR16"
      >
        <span
          style={{ display: 'block' }}
          className={'font22 latoLight appendBottom2'}
        >
          {`Basic information for ${operatorName}`}
        </span>
      </h2>
      <div className={styles.genericInformationWarp}>
        <div className={`${styles.genericInformationText}`}>
          {ownedBy && (
            <p className="appendBottom3">
              <span className={styles.genericInformationKey}>
                {'Owned by : '}
              </span>
              {ownedBy}
            </p>
          )}
          {headOffice ? (
            <p className="appendBottom3">
              <span className={styles.genericInformationKey}>
                {'Head office : '}
              </span>
              {headOffice}
            </p>
          ) : (
            ''
          )}
          {noOfBuses && noOfBuses > 0 ? (
            <p className="appendBottom3">
              <span className={styles.genericInformationKey}>
                {`Total Number of Buses Offered By ${operatorName} : `}
              </span>
              {noOfBuses}
            </p>
          ) : (
            ''
          )}
          {noOfRoutes && noOfRoutes > 0 ? (
            <p className="appendBottom3">
              <span className={styles.genericInformationKey}>
                {`Total Number Of Routes Covered By ${operatorName} : `}
              </span>
              {noOfRoutes}
            </p>
          ) : (
            ''
          )}
          {typeOfBuses && typeOfBuses.length > 0 ? (
            <p className="appendBottom3">
              <span className={styles.genericInformationKey}>
                {`Type of Buses Offered : `}
              </span>
              {typeOfBuses.join(', ')}
            </p>
          ) : (
            ''
          )}
          {areaServedBy && areaServedBy.length > 0 ? (
            <p className="appendBottom3">
              <span className={styles.genericInformationKey}>
                {`Area Served by ${operatorName} : `}
              </span>
              {areaServedBy.join(', ')}
            </p>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default OperatorGenericInformation;
